import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {commentsData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{commentsData.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.items.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-300 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-800">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}